
import React from "react";

export function useInView<T extends HTMLElement = HTMLDivElement>(threshold = 0.15): [React.RefObject<T | null>, boolean] {
    const ref = React.useRef<T>(null);
    const [inView, setInView] = React.useState<boolean>(false);
    React.useEffect(() => {
        const el = ref.current;
        if (!el) return;
        const obs = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                setInView(true);
                obs.disconnect();
            }
        }, { threshold });
        obs.observe(el);
        return () => obs.disconnect();
    }, [threshold]);
    return [ref, inView];
}
